<template>
  <v-app class="main">
    <v-main>
      <MobileHeader v-if="$vuetify.breakpoint.smAndDown" />
      <Header v-else />
      <router-view />
      <Footer />
    </v-main>
  </v-app>
</template>

<script>
import MobileHeader from "@/components/MobileHeader";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "App",
  components: {
    Header,
    MobileHeader,
    Footer,
  },
};
</script>

<style lang="scss">
.theme--light.v-application {
  color: $default-text-color !important;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>
